export default __webpack_public_path__ + "static/media/ebook-box-image-06.096a8953.png";